<ng-container *ngIf="loading">
    <app-loader></app-loader>
</ng-container>

<app-abstract-dialog *ngIf="!loading" [dialogWidth]="'600'">

    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{ username }} {{ 'GENERAL.INFORMATION' | translate}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <form [formGroup]="form">
            <div class="user-more-info-dialog__content">
                <div class="gender-field">
                    <p class="user-more-info-dialog__content__label">{{'USER.GENDER' | translate}}</p>
                    <div class="user-more-info-dialog__content__inner" [attr.aria-label]="'USER.GENDER' | translate"
                         role="radiogroup">
                        <app-radio-button
                                [nameForIsolation]="'genderGroup'"
                                [label]="'USER.GENDER_MALE' | translate"
                                [checked]="saveRequest.gender == male"
                                (radioButtonChanged)="onGenderChange(male)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'genderGroup'"
                                [label]="'USER.GENDER_FEMALE' | translate"
                                [checked]="saveRequest.gender == female"
                                (radioButtonChanged)="onGenderChange(female)">
                        </app-radio-button>
                    </div>
                </div>

                <div class="age-field">
                    <mat-form-field class="mat-form-style" appearance="outline">
                        <mat-label class="user-more-info-dialog__content__label">{{'USER.AGE' | translate}}</mat-label>
                        <input matInput [formControl]="ageFormControl"
                               class="input-field" type="text" maxlength="3">
                        <mat-error *ngIf="this.ageFormControl.errors?.ageInvalid"
                                   [attr.aria-invalid]="true">{{'USER.INVALID_INPUT' | translate}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="injections-field">
                    <p class="user-more-info-dialog__content__label">{{'USER.NUMBER_OF_INJECTIONS' | translate}}</p>
                    <div class="user-more-info-dialog__content__inner"
                         [attr.aria-label]="'USER.NUMBER_OF_INJECTIONS' | translate" role="radiogroup">
                        <app-radio-button
                                [nameForIsolation]="'injectionsGroup'"
                                [label]="'USER.INJECTIONS_NONE' | translate"
                                [checked]="saveRequest.numberOfInjections === injectionsNone"
                                (radioButtonChanged)="onInjectionChange(injectionsNone)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'injectionsGroup'"
                                [label]="'USER.INJECTIONS_1_TO_5' | translate"
                                [checked]="saveRequest.numberOfInjections === injections1to5"
                                (radioButtonChanged)="onInjectionChange(injections1to5)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'injectionsGroup'"
                                [label]="'USER.INJECTIONS_6_TO_10' | translate"
                                [checked]="saveRequest.numberOfInjections === injections6to10"
                                (radioButtonChanged)="onInjectionChange(injections6to10)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'injectionsGroup'"
                                [label]="'USER.INJECTIONS_11_TO_20' | translate"
                                [checked]="saveRequest.numberOfInjections === injections11to20"
                                (radioButtonChanged)="onInjectionChange(injections11to20)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'injectionsGroup'"
                                [label]="'USER.INJECTIONS_MORE_THAN_20' | translate"
                                [checked]="saveRequest.numberOfInjections === injectionsMoreThan20"
                                (radioButtonChanged)="onInjectionChange(injectionsMoreThan20)">
                        </app-radio-button>
                    </div>
                </div>
                <div class="eye-vision-field">
                    <mat-form-field class="mat-form-style" appearance="outline">
                        <mat-label
                                class="user-more-info-dialog__content__label">{{'USER.BETTER_VISION' | translate}}</mat-label>
                        <input matInput
                               [formControl]="betterEyeVisionFormControl" class="input-field" type="text" maxlength="3">
                        <span matSuffix>%</span>
                        <mat-error *ngIf="this.betterEyeVisionFormControl.errors?.visionInvalid"
                                   [attr.aria-invalid]="true">{{'USER.INVALID_INPUT' | translate}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="it-experience-field">
                    <p class="user-more-info-dialog__content__label">{{'USER.IT_EXPERIENCE' | translate}}</p>
                    <div class="user-more-info-dialog__content__inner"
                         [attr.aria-label]="'USER.IT_EXPERIENCE' | translate" role="radiogroup" [attr.tabindex]="-1">
                        <app-radio-button
                                [nameForIsolation]="'itGroup'"
                                [label]="'USER.IT_EXPERIENCE_NONE' | translate"
                                [checked]="saveRequest.itExperience === itNone"
                                (radioButtonChanged)="onItExperienceChange(itNone)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'itGroup'"
                                [label]="'USER.IT_EXPERIENCE_POOR' | translate"
                                [checked]="saveRequest.itExperience === itPoor"
                                (radioButtonChanged)="onItExperienceChange(itPoor)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'itGroup'"
                                [label]="'USER.IT_EXPERIENCE_PRETTY_WELL' | translate"
                                [checked]="saveRequest.itExperience === itPrettyWell"
                                (radioButtonChanged)="onItExperienceChange(itPrettyWell)">
                        </app-radio-button>
                        <app-radio-button
                                [nameForIsolation]="'itGroup'"
                                [label]="'USER.IT_EXPERIENCE_VERY_GOOD' | translate"
                                [checked]="saveRequest.itExperience === itVeryGood"
                                (radioButtonChanged)="onItExperienceChange(itVeryGood)">
                        </app-radio-button>
                    </div>
                </div>
            </div>
        </form>

    </ng-container>
    <ng-container abstract-footer>
        <div class="footer-content">
            <div class="button-wrapper">
                <app-button type="submit"
                            [cssClasses]="'btn full-width solid__blue-07'"
                            (buttonClicked)="onUpdateUserPersonal()">
                    {{'GENERAL.SAVE' | translate}}
                </app-button>
            </div>
        </div>
    </ng-container>

</app-abstract-dialog>
